module.exports = __webpack_public_path__ + "images/application/illustrations/banner-pipes-bg-16cf58bd.svg";